import React from 'react';
import { observer } from 'mobx-react';
import { Auth } from '@whatsper/texterchat-common';
import { useStore } from '../../../store/rootStore';
import Password from './methods/Password';
import OTP from './methods/OTP';
import SAML from './methods/SAML';
var Method = Auth.Methods.Method;
const LoginMethod = ({ method, shouldUpdatePassword }) => {
    const { loginStore } = useStore();
    const handleBack = () => {
        loginStore.setAuthMethods(loginStore.availableAuthMethods);
    };
    // Only show back button if there are multiple available auth methods
    const showBackButton = loginStore.availableAuthMethods.length > 1;
    switch (method) {
        case Method.password:
            return (React.createElement(Password, { shouldUpdatePassword: shouldUpdatePassword, onSubmit: loginStore.loginWithPassword, onBack: showBackButton ? handleBack : undefined }));
        case Method.whatsapp_otp:
            return React.createElement(OTP, { method: Method.whatsapp_otp, onSubmit: loginStore.loginWithWhatsAppOTP, onBack: showBackButton ? handleBack : undefined });
        case Method.totp:
            return React.createElement(OTP, { method: Method.totp, onSubmit: loginStore.loginWithTOTP, onBack: showBackButton ? handleBack : undefined });
        case Method.saml:
            return React.createElement(SAML, { onBack: showBackButton ? handleBack : undefined });
        default:
            console.error('Unsupported login method: ' + method);
            // TODO: Better error message
            return React.createElement("div", null, "Login method not supported");
    }
};
export default observer(LoginMethod);
